import { useNavigate } from "react-router-dom";
import React, { useState, useRef, useEffect } from 'react';
import { Ripple } from 'primereact/ripple';
import { StyleClass } from 'primereact/styleclass';
import { classNames } from 'primereact/utils';
import BossIcon from '../../assets/icons/image.png';
import { Sidebar } from 'primereact/sidebar';
import './Sidebar.css';
import ThemeSwitcher from "../../theme/ThemeSwitcher";
import CookieHandler from "../../pages/LandingPage/Authentication/CookieHandler"

const SidebarComponent = ({ activePath, isSideBarActive, toggleSidebar }) => {
  const navigate = useNavigate();
  const [isDesktop, setIsDesktop] = useState(window.innerWidth > 600);

  const btnRef1 = useRef(null);
  const btnRef2 = useRef(null);
  const btnRef3 = useRef(null);
  const btnRef4 = useRef(null);


  const handleLogout = () => {
    CookieHandler.clear();
    CookieHandler.setCookie('isLoggedIn', 'false');
    navigate('/login');
  };

  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth > 600);
    };

    window.addEventListener('resize', handleResize);

    // Cleanup listener on component unmount
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

 
 
  return (
    <Sidebar
    visible={isSideBarActive || isDesktop}
    modal={false}
    dismissable={!isDesktop}
    showCloseIcon={!isDesktop}
    onHide={!isDesktop ? toggleSidebar : null}
    content={({ closeIconRef, hide }) => (
                            <div className="flex flex-column h-full">
                                <div className="flex align-items-center justify-content-between px-4 pt-3 flex-shrink-0">
                                <button type="button" className="p-link layout-menu-button layout-topbar-button large-screen-only" onClick={toggleSidebar}>
                                    <i className="pi pi-bars" />
                                </button>
                                    <span className="inline-flex align-items-center gap-2">
                                        <img src={BossIcon}  style={{width:"150px"}} alt="boss-Icon"/>
                                    </span>
                                    <span>
                                        <ThemeSwitcher/>
                                    </span>
                                </div>
                                <br/>
                                <br/>
                                <div className="overflow-y-auto">
                                    <ul className="list-none p-3 m-0">
                                        <li>
                                    
                                            <ul className="list-none p-0 m-0 overflow-hidden">
                                                <li>
                                                <a className={classNames('p-ripple flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors w-full',{ 'text-[#0094DC]': activePath === 'Dashboard' })}
                                                    onClick={() => { navigate("/store"); }}>
                                                    <i className="pi pi-home mr-2"></i>
                                                    <span className='font-medium'>Dashboard</span>
                                                    <Ripple />
                                                </a>
                                                </li>
                                                <li>
                                                    <a className="p-ripple flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors w-full"
                                                        onClick={() => { navigate("/store/view"); }}>
                                                        <i className="pi pi-bookmark mr-2"></i>
                                                        <span className="font-medium">Store</span>
                                                        <Ripple />
                                                    </a>
                                                </li>

                                                <li>
                                                    <a className="p-ripple flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors w-full"
                                                        onClick={() => { navigate("/store/products"); }}>
                                                        <i className="pi pi-list mr-2"></i>
                                                        <span className="font-medium">Products</span>
                                                        <Ripple />
                                                    </a>
                                                </li>
                                                <li>
                                                    <StyleClass nodeRef={btnRef2} selector="@next" enterClassName="hidden" enterActiveClassName="slidedown" leaveToClassName="hidden" leaveActiveClassName="slideup">
                                                        <a ref={btnRef2} className="p-ripple flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors w-full"
                                                            >
                                                            <i className="pi pi-receipt mr-2"></i>
                                                            <span className="font-medium">Manage Orders</span>
                                                            <i className="pi pi-chevron-down ml-auto mr-1"></i>
                                                            <Ripple />
                                                        </a>
                                                    </StyleClass>
                                                    <ul className="list-none py-0 pl-3 pr-0 m-0 hidden overflow-y-hidden transition-all transition-duration-400 transition-ease-in-out">
                                                                <li>
                                                                    <a className="p-ripple flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors w-full"
                                                                        onClick={() => { navigate("/store/orders"); }}>
                                                                        <i className="pi pi-table mr-2"></i>
                                                                        <span className="font-medium">View all orders</span>
                                                                        <Ripple />
                                                                    </a>
                                                                </li>
                                                        <li>
                                                            <a className="p-ripple flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors w-full"
                                                                onClick={() => { navigate("/store/product-orders"); }}>
                                                                <i className="pi pi-chart-line mr-2"></i>
                                                                <span className="font-medium">product orders</span>
                                                                <Ripple />
                                                            </a>
                                                        </li>
                                                    </ul>
                                                </li>
                                                
                                                
                                                  
                                                <li>
                                                    <a className="p-ripple flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors w-full"
                                                        onClick={() => { navigate("/store/messages"); }}>
                                                        <i className="pi pi-comments mr-2"></i>
                                                        <span className="font-medium">Customer support</span>
                                                        <span className="inline-flex align-items-center justify-content-center ml-auto bg-blue-500 text-0 border-circle" style={{ minWidth: '1.5rem', height: '1.5rem' }}>
                                                            3
                                                        </span>
                                                        <Ripple />
                                                    </a>
                                                </li>
                                                <li>
                                                    <a className="p-ripple flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors w-full"
                                                        onClick={() => { navigate("/store/coupons"); }}>
                                                        <i className="pi pi-ticket mr-2"></i>
                                                        <span className="font-medium">Coupons</span>
                                                        <Ripple />
                                                    </a>
                                                </li>
                                                <li>
                                                    <a className="p-ripple flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors w-full" 
                                                        onClick={() => {navigate("/store/settings");}}>
                                                        <i className="pi pi-cog mr-2"></i>
                                                        <span className="font-medium">Settings</span>
                                                        <Ripple />
                                                    </a>
                                                </li>
                                            </ul>
                                        </li>
                                    </ul>
                                   
                                </div>
                                <div className="mt-auto">
                                    <hr className="mb-3 mx-3 border-top-1 border-none surface-border" />
                                    <a v-ripple className="m-3 flex align-items-center cursor-pointer p-3 gap-2 border-round text-700 hover:surface-100 transition-duration-150 transition-colors p-ripple" onClick={handleLogout}>
                                        <span className="font-bold">Logout</span>
                                        <i className="pi pi-sign-out mr-2"></i>
                                    </a>

                                    <div className="m-3 flex align-items-center p-3 gap-2 border-round text-700 ">
                                        <span className="font-bold">Powered By M2R2</span>
                                    </div>
                                </div>
                                
                        </div>
                    )}
                    ></Sidebar>
            
  );
};

export default SidebarComponent;